import { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LoginCallback } from '@okta/okta-react';

import LoginCallbackError from 'containers/login/okta-widget/login-callback-error';

interface CallbackErrorProps {
  error: Error;
}

const ImplicitCallback = (): React.JSX.Element => {
  const navigate = useNavigate();
  //Store URL search parameters in state so they are not lost of page redirect
  const [callbackSearch] = useState(() => window.location.search);

  const CallbackError = useMemo(() => {
    const Component = ({ error }: CallbackErrorProps) => (
      <LoginCallbackError error={error} callbackSearch={callbackSearch} />
    );

    Component.displayName = 'CallbackError';

    return Component;
  }, [callbackSearch]);

  const onAuthResume = async () => {
    navigate('/login');
  };

  return (
    <LoginCallback onAuthResume={onAuthResume} errorComponent={CallbackError} />
  );
};

export default ImplicitCallback;
